(function () {
  'use strict';

  var POSITIONS = {
    '-2': { y: -250, scale: 0.70, opacity: 0.30, zIndex: 3, rotateX:  15 },
    '-1': { y: -145, scale: 0.82, opacity: 0.60, zIndex: 4, rotateX:   8 },
     '0': { y:    0, scale: 1.00, opacity: 1.00, zIndex: 5, rotateX:   0 },
     '1': { y:  145, scale: 0.82, opacity: 0.60, zIndex: 4, rotateX:  -8 },
     '2': { y:  250, scale: 0.70, opacity: 0.30, zIndex: 3, rotateX: -15 },
  };

  var COOLDOWN = 400;

  function initVStack(sectionId) {
    var products = window['vstackProducts_' + sectionId];
    if (!products || !products.length) return;

    var stage     = document.getElementById('vstack-stage-'   + sectionId);
    var loading   = document.getElementById('vstack-loading-' + sectionId);
    var elCurrent = document.getElementById('vstack-current-' + sectionId);
    var elTotal   = document.getElementById('vstack-total-'   + sectionId);
    var wrapper   = document.getElementById('vstack-'         + sectionId);
    if (!stage) return;

    if (loading) loading.style.display = 'none';

    var total         = products.length;
    var currentIndex  = 0;
    var lastNavTime   = 0;
    var isDragging    = false;
    var dragStartY    = 0;
    var dragCurrentY  = 0;
    var cards         = [];

    // ── counter ──────────────────────────────────────────────
    function updateCounter() {
      if (elCurrent) elCurrent.textContent = pad(currentIndex + 1);
      if (elTotal)   elTotal.textContent   = pad(total);
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    // ── circular diff ─────────────────────────────────────────
    function getDiff(index) {
      var d = index - currentIndex;
      var h = Math.floor(total / 2);
      if (d >  h) d -= total;
      if (d < -h) d += total;
      return d;
    }

    // ── apply positions ───────────────────────────────────────
    function applyPositions(dragOffset, animate) {
      dragOffset = dragOffset || 0;
      cards.forEach(function (card, i) {
        var d   = getDiff(i);
        var pos = POSITIONS[String(d)];
        var yVal, opVal, scaleVal, ziVal, rxVal;

        if (pos) {
          yVal     = (d === 0) ? pos.y + dragOffset : pos.y;
          opVal    = pos.opacity;
          scaleVal = pos.scale;
          ziVal    = pos.zIndex;
          rxVal    = pos.rotateX;
        } else {
          yVal     = d > 0 ? 400 : -400;
          opVal    = 0;
          scaleVal = 0.6;
          ziVal    = 0;
          rxVal    = 0;
        }

        card.style.transition = animate === false ? 'none' : '';
        card.style.transform  = 'translateY(' + yVal + 'px) scale(' + scaleVal + ') rotateX(' + rxVal + 'deg)';
        card.style.opacity    = opVal;
        card.style.zIndex     = ziVal;
        card.style.visibility = opVal === 0 ? 'hidden' : 'visible';
        card.className = 'vstack-card' + (d === 0 ? ' vstack-card--active' : '');
      });
    }

    // ── navigate ──────────────────────────────────────────────
    function navigate(dir) {
      var now = Date.now();
      if (now - lastNavTime < COOLDOWN) return;
      lastNavTime  = now;
      currentIndex = (currentIndex + dir + total) % total;
      applyPositions(0, true);
      updateCounter();
    }

    // ── add to cart ───────────────────────────────────────────
    function addToCart(variantId, btn) {
      if (!variantId || btn.disabled) return;
      var orig    = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled    = true;

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            showBtnState(btn, 'Error', orig, false);
          } else {
            showBtnState(btn, 'Added!', orig, true);
            document.dispatchEvent(new CustomEvent('cart:updated'));
            // refresh mini-cart drawer if theme supports it
            var ev = new CustomEvent('theme:cart:add', { detail: { response: data } });
            document.dispatchEvent(ev);
          }
        })
        .catch(function () { showBtnState(btn, 'Error', orig, false); });
    }

    function showBtnState(btn, label, orig, success) {
      btn.textContent = label;
      if (success) btn.classList.add('is-added');
      setTimeout(function () {
        btn.textContent = orig;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 2000);
    }

    // ── build cards ───────────────────────────────────────────
    function escapeHtml(s) {
      return String(s || '')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    products.forEach(function (p, i) {
      var card = document.createElement('div');
      card.className        = 'vstack-card';
      card.dataset.index    = i;
      card.style.transition = '';

      var imgHtml = p.image
        ? '<img class="vstack-card__img" src="' + p.image + '" alt="' + escapeHtml(p.imageAlt) + '" loading="lazy">'
        : '<div class="vstack-card__img-placeholder"></div>';

      var atcLabel    = p.available ? 'Add to Cart' : 'Sold Out';
      var atcDisabled = p.available ? '' : 'disabled';

      card.innerHTML =
        imgHtml +
        '<div class="vstack-card__body">' +
          '<p class="vstack-card__title">' + escapeHtml(p.title) + '</p>' +
          '<p class="vstack-card__price">' + escapeHtml(p.price) + '</p>' +
          '<button class="vstack-card__atc" data-variant="' + p.variantId + '" ' + atcDisabled + '>' + atcLabel + '</button>' +
        '</div>';

      // card click → product page (only when it's the active card)
      card.addEventListener('click', function (e) {
        if (e.target.closest('.vstack-card__atc')) return;
        if (isDragging) return;
        var idx = parseInt(card.dataset.index, 10);
        if (idx === currentIndex) {
          window.location.href = p.url;
        } else {
          var now = Date.now();
          if (now - lastNavTime >= COOLDOWN) {
            lastNavTime  = now;
            currentIndex = idx;
            applyPositions(0, true);
            updateCounter();
          }
        }
      });

      // ATC button
      var atcBtn = card.querySelector('.vstack-card__atc');
      if (atcBtn) {
        atcBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          addToCart(p.variantId, atcBtn);
        });
      }

      stage.appendChild(card);
      cards.push(card);
    });

    // ── drag / touch ──────────────────────────────────────────
    function onPointerDown(e) {
      isDragging  = false;
      dragStartY  = e.clientY;
      dragCurrentY = e.clientY;
      document.addEventListener('mousemove', onPointerMove);
      document.addEventListener('mouseup',   onPointerUp);
    }

    function onPointerMove(e) {
      var delta = e.clientY - dragStartY;
      if (Math.abs(delta) > 5) isDragging = true;
      dragCurrentY = e.clientY;
      if (isDragging) applyPositions(delta * 0.5, false);
    }

    function onPointerUp() {
      document.removeEventListener('mousemove', onPointerMove);
      document.removeEventListener('mouseup',   onPointerUp);
      var delta = dragCurrentY - dragStartY;
      if (Math.abs(delta) > 50) navigate(delta < 0 ? 1 : -1);
      else applyPositions(0, true);
      setTimeout(function () { isDragging = false; }, 50);
    }

    function onTouchStart(e) {
      dragStartY   = e.touches[0].clientY;
      dragCurrentY = e.touches[0].clientY;
      isDragging   = false;
      document.addEventListener('touchmove', onTouchMove, { passive: true });
      document.addEventListener('touchend',  onTouchEnd);
    }

    function onTouchMove(e) {
      var delta = e.touches[0].clientY - dragStartY;
      if (Math.abs(delta) > 5) isDragging = true;
      dragCurrentY = e.touches[0].clientY;
      if (isDragging) applyPositions(delta * 0.5, false);
    }

    function onTouchEnd() {
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend',  onTouchEnd);
      var delta = dragCurrentY - dragStartY;
      if (Math.abs(delta) > 50) navigate(delta < 0 ? 1 : -1);
      else applyPositions(0, true);
      setTimeout(function () { isDragging = false; }, 50);
    }

    stage.addEventListener('mousedown',  onPointerDown);
    stage.addEventListener('touchstart', onTouchStart, { passive: true });

    // ── wheel (scoped to wrapper) ─────────────────────────────
    if (wrapper) {
      wrapper.addEventListener('wheel', function (e) {
        e.preventDefault();
        if (Math.abs(e.deltaY) > 20) navigate(e.deltaY > 0 ? 1 : -1);
      }, { passive: false });
    }

    // ── arrow buttons ─────────────────────────────────────────
    if (wrapper && stage) {
      // Inject styles once
      if (!document.getElementById('vstack-arrow-css')) {
        var arrowStyle = document.createElement('style');
        arrowStyle.id = 'vstack-arrow-css';
        arrowStyle.textContent = [
          '.vstack-arrow{display:flex;align-items:center;justify-content:center;',
          'width:44px;height:44px;border-radius:50%;border:2px solid rgba(255,255,255,0.18);',
          'background:rgba(255,255,255,0.07);color:#fff;cursor:pointer;',
          'margin:0 auto;flex-shrink:0;user-select:none;',
          'transition:background .2s,border-color .2s,transform .15s;}',
          '.vstack-arrow:hover{background:#FF6200;border-color:#FF6200;transform:scale(1.1);}',
          '.vstack-arrow:active{transform:scale(0.93);}',
          '.vstack-arrow--prev{margin-bottom:12px;}',
          '.vstack-arrow--next{margin-top:12px;}',
          '@media(max-width:768px){.vstack-arrow{width:40px;height:40px;}}',
        ].join('');
        document.head.appendChild(arrowStyle);
      }

      function makeArrowBtn(dir) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vstack-arrow vstack-arrow--' + (dir < 0 ? 'prev' : 'next');
        btn.setAttribute('aria-label', dir < 0 ? 'Previous product' : 'Next product');
        var pts = dir < 0 ? '18 15 12 9 6 15' : '6 9 12 15 18 9';
        btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"'
          + ' stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">'
          + '<polyline points="' + pts + '"/></svg>';
        btn.addEventListener('click', function () { navigate(dir); });
        return btn;
      }

      wrapper.insertBefore(makeArrowBtn(-1), stage);
      stage.insertAdjacentElement('afterend', makeArrowBtn(1));
    }

    // ── init ──────────────────────────────────────────────────
    applyPositions(0, false);
    updateCounter();
  }

  function setup() {
    document.querySelectorAll('[data-vstack-section]').forEach(function (el) {
      initVStack(el.dataset.vstackSection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
